'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.YouTube = void 0;
const $ = require("jquery");
class YouTube {
    constructor() {
        // YouTubeカバーリサイズ初期化
        this.initYouTubeCover();
    }
    initYouTubeCover() {
        // アスペクト比文字列を数値に変換
        const parseAspect = (str) => {
            if (!str)
                return 16 / 9;
            const m = str.match(/^(\d+)\s*\/\s*(\d+)$/);
            return m ? Number(m[1]) / Number(m[2]) : 16 / 9;
        };
        // カバー表示にリサイズ
        const fitCover = ($wrap) => {
            // iframe 要素がない場合は何もしない
            const $iframe = $wrap.find("iframe");
            // iframe 要素が存在しない場合は終了
            if ($iframe.length === 0)
                return;
            // アスペクト比取得
            const aspectAttr = $wrap.data("aspect");
            // デフォルトは16:9
            const aspect = parseAspect(aspectAttr);
            // ラップ要素のサイズ取得
            const W = ($wrap.width() ?? 0);
            // 高さは0除算防止
            const H = ($wrap.height() ?? 0);
            // 0除算防止
            if (W === 0 || H === 0)
                return;
            // ラップ要素のアスペクト比計算
            const containerAR = W / H;
            if (containerAR > aspect) {
                // 横長 → 幅を合わせて高さをトリミング
                const w = W;
                const h = Math.ceil(W / aspect);
                $iframe.css({ width: w, height: h });
            }
            else {
                // 縦長 → 高さを合わせて幅をトリミング
                const h = H;
                const w = Math.ceil(H * aspect);
                $iframe.css({ width: w, height: h });
            }
        };
        // 対象要素取得
        const $targets = $(".bulletYouTube");
        // 要素がない場合は終了
        if ($targets.length === 0)
            return;
        // ResizeObserverでリサイズ監視
        const ro = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const el = entry.target;
                fitCover($(el));
            }
        });
        // 各要素に対して初期化と監視開始
        $targets.each((_i, el) => {
            const $el = $(el);
            fitCover($el);
            ro.observe(el);
        });
        // ウィンドウリサイズ時にも対応（ResizeObserverが効かない場合の保険）
        $(window).on("resize", () => {
            $targets.each((_i, el) => {
                fitCover($(el));
            });
        });
        // iPhoneの画面ロック対策
        const iframe = $('.bulletYouTube iframe');
        const src = iframe.attr('src');
        // ページが非表示→再表示になったとき
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                iframe.css('opacity', 0);
                iframe.attr('src', src + (src.includes('?') ? '&' : '?') + 't=' + Date.now());
                // 再描画後にフェードイン
                setTimeout(() => {
                    iframe.css('opacity', 1);
                }, 300);
            }
        });
    }
}
exports.YouTube = YouTube;
exports.default = YouTube;
